import { render } from "./NewOneOnOneDialog.vue?vue&type=template&id=242a7737&scoped=true"
import script from "./NewOneOnOneDialog.vue?vue&type=script&lang=js"
export * from "./NewOneOnOneDialog.vue?vue&type=script&lang=js"

import "./NewOneOnOneDialog.vue?vue&type=style&index=0&id=242a7737&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-242a7737"

export default script